import { space } from '../spacing.js';
import { colors } from '../colors.js';
import { sizes } from '../sizing.js';
export const base = {
    itemSeparator: {
        style: 'leftInnerBorder',
        color: 'white',
        alpha: 'x2',
    },
};
export const navItem = {
    paddingLeft: space.x3,
    paddingRight: space.x3,
};
export const topBar = {
    height: sizes.x12,
    color: colors.text.onDark,
    backgroundColor: colors.brand.navy,
};
//# sourceMappingURL=navigation.js.map